import { useTranslation } from 'react-i18next';

import { PanelSection } from './PanelSection';

// Placeholder — no tags field exists on Chats/LoanRequest/Applicant; needs its own event/read-model.
export const TagsSection = () => {
    const { t } = useTranslation();

    return (
        <PanelSection title={t('WHATSAPP_CHAT.USER_INFO.TAGS.TITLE')}>
            <p className="py-1.5 text-sm text-grey">{t('WHATSAPP_CHAT.USER_INFO.TAGS.COMING_SOON')}</p>
        </PanelSection>
    );
};
